import React from 'react';

function WindowsLinuxContent() {
  return (
    <>
      <p>Information regarding the availability of RepoPrompt on Windows and Linux platforms.</p>
      <h3>Current Status</h3>
      <p>RepoPrompt is currently only available for macOS.</p>
      <h3>Future Plans</h3>
      <p>This is something being considered, but Repo Prompt is a native macOS app, which means it is built with deep mac native API integration. This is important for performance reasons (large repositories can tax your app quite easily), and also because file systems between operating systems require a lot of careful consideration. The current near term priority remains to support the mac version, but you can join the waitlist to be notified if platform availability changes:</p>
      <p><a href="https://forms.gle/TGx1ZuT3oqng7EuKA" target="_blank" rel="noopener noreferrer">https://forms.gle/TGx1ZuT3oqng7EuKA</a></p>
    </>
  );
}

export default WindowsLinuxContent;